/**
 * Inline styles for the "Reason for Change" sweetalert2 dialogs (ClientList
 * activate/deactivate, ClientForm critical-field edit).
 *
 * The two dialogs differ in wording, options and validation, so each builds
 * its own `html`; they share only these field styles. Swal `html` is a string,
 * so the styles are inline — colours come from the theme tokens via var(),
 * which resolves because the dialog is rendered into the page's DOM.
 */
export const REASON_LABEL_STYLE =
  'display:block;font-size:15px;font-weight:600;margin-bottom:4px;';

export const REASON_REQUIRED_MARK = '<span style="color:var(--neg);">*</span>';

export const REASON_SELECT_STYLE =
  'display:block;width:100%;box-sizing:border-box;padding:8px;border:1px solid var(--border-strong);border-radius:4px;font-size:14px;margin-bottom:12px;';

export const REASON_TEXTAREA_STYLE =
  'display:block;width:100%;box-sizing:border-box;padding:8px;border:1px solid var(--border-strong);border-radius:4px;font-size:14px;resize:vertical;font-family:inherit;';
